/*
 *  Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
 *
 *  All information herein, source code below as well as the Morpheus system itself and all related
 *  software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
 *  Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
 *  is prohibited.
 */

import store from '../store'
import { Route } from 'vue-router'
import { getTokenDate } from '@morpheus/admin/admin-vue/store/modules/auth'

export default function (to: Route, fromR: Route, next: Function) {
  const authToken = store.getters['auth/accessToken']

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (authToken && isJwtExpTimestampValid()) {
      next()
    } else {
      store.commit('auth/logout')
      next('/login?loginError=true')
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (authToken) {
      next('/')
    } else {
      next()
    }
  } else {
    next()
  }
}

function isJwtExpTimestampValid () {
  const now: number = (new Date()).getTime()
  const jwtExpTimestamp = store.getters['auth/jwtExpTimestamp']
  if (!jwtExpTimestamp) {
    getTokenDate('jwtExpTimestamp')
  }

  return jwtExpTimestamp > now / 1000
}
